import { Tabs } from './tabs';

export * from './tabs-props';
export * from './tab-props';
export * from './tab-panel-props';
export * from './tab';
export * from './tab-panel';

export default Tabs;
